module.exports = __webpack_public_path__ + "img/temporarily-banned.5a31e15e.webp";